import { render, staticRenderFns } from "./ReportImageDamageDetailRequired.vue?vue&type=template&id=5c536f05"
import script from "./ReportImageDamageDetailRequired.vue?vue&type=script&lang=ts"
export * from "./ReportImageDamageDetailRequired.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports